module.exports = __webpack_public_path__ + "static/img/exhibitor_normal_cn.adc07e68.png";